<template>
  <div class="home">
    <br />
    <img alt="Control T" src="../assets/logo.png" />
    <br>
    <Login/>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Login from '@/components/login.vue'

export default {
  name: 'home',
  components: {
    Login
  }
}
</script>
